var map = {
	"./上海/官网/4.jpg": 3575,
	"./北京/官网/4.jpg": 16359,
	"./南京/官网/4.jpg": 84287,
	"./广州/官网/4.jpg": 17833,
	"./成都/官网/4.jpg": 89478,
	"./杭州/官网/4.jpg": 82253,
	"./武汉/官网/4.jpg": 28593,
	"./深圳/官网/4.jpg": 92181
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 23086;